<header>
  @if (menuToggleEnabled) {
    <button
      type="button"
      title="Toggle menu"
      class="menu-button"
      (click)="toggleMenu()"
      >
      <i class="dx-icon dx-icon-menu"></i>
    </button>
  }
  @if (imageSource) {
    <img [src]="imageSource" alt="logo" class="brand-logo" />
  }
  <div class="brand-copy">
    <span class="brand-kicker">{{ sectionParent || 'Workspace' }}</span>
    <div class="brand-title-row">
      <span class="brand-title">{{ sectionTitle || title }}</span>
    </div>
  </div>

  <ai-ask-bar />

  <div class="header-actions">
    <schedule-of-charges-shortcut />
    <portal-shortcut />
    <patricia-shortcut />
    <time-registration-shortcut />
    <wiki-shortcut />
    <theme-switcher />
    <notifications-panel />
    <user-panel [user]="user" [menuItems]="userMenuItems" menuMode="context" />
  </div>
</header>
